module.exports = function(app) {
    app.directive('eprHotKeys', ['$document', '$state', function($document, $state) {

        $document.on('keyup', function(e) {
            // Skip if it focused in input tag.
            if (event.target.tagName !== "INPUT") {
                    // Skip if it focused in input tag.
                    if (event.target.tagName !== 'INPUT'
                        && (e.key == 'l' && e.altKey == true && e.ctrlKey == true)) {
                        $state.go('employee.find');
                    }
            }
        })

        return {
            restrict: 'A',
            link: function(scope, element, attrs) {

            }
        };
    }])  }